import React, { useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal, { ModalContext } from '@saucelabs/ds-modal';
import { modalConnectV2 } from '@saucelabs/sl-container-modal';
import { Loader } from '@saucelabs/sl-component-loader';
import { NoData } from '@saucelabs/ds-data-states';

import constants from '../constants';
import selectors from '../selectors';
import actions from '../actions';
import FilesList from './FilesList';
import FilesSearch from './FilesSearch';

const FilesModal: React.FC = () => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const { isOpen } = useContext(ModalContext);
  const { files, hasDataFetched } = useSelector(selectors.filesModalSelector);

  useEffect(() => {
    if (isOpen && !hasDataFetched) {
      void dispatch(actions.fetchAppStorageFiles());
    }
  }, [isOpen, hasDataFetched, dispatch]);

  useEffect(() => {
    dispatch(actions.reset());
  }, [dispatch]);

  return (
    <Modal
      actionButtonProps={{ className: 'hidden' }} // action/hide buttons are rendered only together
      hideButtonProps={{ children: 'Close' }}
      onConfirm={() => { /* needed to render modal buttons at all */ }}
      size="large"
      title="Install Dependent App"
    >
      <Loader
        className="mx-auto my-7"
        data-qa="install-dependent-app-list-loader"
        show={!hasDataFetched}
      >
        <FilesSearch />

        {files.length === 0 && (
          <NoData
            className="mx-auto"
            spacing="large"
          />
        )}

        {files.length !== 0 && (
          <FilesList />
        )}
      </Loader>
    </Modal>
  );
};

FilesModal.displayName = 'InstallDependentAppFilesModal';

export default (modalConnectV2(constants.MODAL_KEY, FilesModal));
